import React, { useState } from 'react'
import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle'
import clsx from 'clsx'

interface Props extends DialogTitleProps {
    className?: string
    /** When false, title is not a drag handle and shows default cursor (e.g. confirmation dialogs). */
    draggable?: boolean
}

const DraggableDialogTitle: React.FC<Props> = ({
    children,
    className,
    sx,
    draggable = true,
    ...props
}) => {
    const [isDragging, setIsDragging] = useState(false)
    const handleMouseDown = () => setIsDragging(true)
    const handleMouseUp = () => setIsDragging(false)

    return (
        <DialogTitle
            className={clsx(draggable && 'draggable-title', className)}
            {...(draggable
                ? {
                      onMouseDown: handleMouseDown,
                      onMouseUp: handleMouseUp,
                      onMouseLeave: handleMouseUp,
                  }
                : {})}
            sx={{
                ...(draggable
                    ? {
                          cursor: isDragging ? 'grabbing' : 'grab',
                          userSelect: 'none',
                      }
                    : { cursor: 'default' }),
                ...sx,
            }}
            {...props}
        >
            {children}
        </DialogTitle>
    )
}

export default DraggableDialogTitle
